import UserPictures from './UserPictures'
export default UserPictures
